import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-m-countries',
  templateUrl: './m-countries.component.html',
  styleUrls: ['./m-countries.component.scss'],
        encapsulation: ViewEncapsulation.None
})
export class MCountriesComponent implements OnInit {

   public countries: any[] = [];
  public messages: any = {};
 
   constructor( 
     private apisService: ApisService,
     // private loadingService: Loadingscr,
     private router: Router,        private toastr : ToastrService,
       public  translate: TranslateService
   ) {} 
 
   public currentPage = 1; 
   public itemsPerPage = 10;
   public totalItems = 0;
 
   public tempData = [];
 
   @ViewChild(DatatableComponent) table: DatatableComponent;
 
   public ColumnMode = ColumnMode;
   public SelectionType = SelectionType;v
 
   ngOnInit(): void {
   
    this.getCountries();
  
      this.setDatatableMessages(); // set initial messages
 
     // listen for language change dynamically
     this.translate.onLangChange.subscribe(() => {
       this.setDatatableMessages();
     });
 
   }
 
    private setDatatableMessages() {
     this.messages = {
       totalMessage: this.translate.instant('MENU.DASHBOARD.total')
     };
   }
 
   getCountries(){ 
   this.apisService.getCountriesM().subscribe({
     next: (response: any) => {
       // The actual array is in response.data.data
         this.countries = response.data || [] ;
 
       this.totalItems = this.countries.length;
       console.log("countries:", this.countries);
     },
     error: (error: any) => {
       console.log(error);
     }
   }
     
   )
  }
  
  
  /*----------  Handling image Error  ----------*/
  onImageError(event) {
   event.target.src = 'assets/images/logo/12.png';
  }
   addCoupon() {
     this.router.navigate(["main/coupons/add-coupon"]);
   }
 
   
 
  
 
   filterUpdate(event) {
     const val = event.target.value.toLowerCase();
     this.countries = this.tempData.filter((d) =>
       d.code.toLowerCase().includes(val)
     );
     this.table.offset = 0;
   }
 
 
   
    /*----------  deleting products  ----------*/
  deleteCountries(id:any){ 
   console.log(id ,' delete id');
   this.apisService.DeleteCountries(id).subscribe({
     next: (response: any) => {
    this.toastr.success(
         this.translate.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
       );       this.getCountries();
     },
     error: (error: any) => {
       console.log(error);
    this.toastr.error(
         this.translate.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
       );    }
   }
     
   )
  } 
 
 editCountries(countryId: number) {
   this.router.navigate(['/edit-m-countries', countryId]);
 }

}
